import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-up\"><title>up</title><path d=\"M10.48 7.919a.865.865 0 1 1-1.223-1.223l2.443-2.444c.17-.17.39-.254.612-.252.221 0 .442.084.613.255l2.441 2.44a.865.865 0 1 1-1.223 1.223l-.983-.966v10.872a.852.852 0 0 1-.849.865.877.877 0 0 1-.88-.865l.015-10.872-.967.967z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol